import { takeLatest } from "redux-saga/effects"

import { apiGeneratorBase, apiGeneratorDelete } from "../../Utils/saga"
import Creators, { RequestsTypes as constants } from "./reducer"
import * as services from "./services"

const actions = {
  saveScreenshotsRequestActions: {
    request: Creators.saveScreenshotsRequestRequest,
    success: Creators.saveScreenshotsRequestSuccess,
    errors: Creators.saveScreenshotsRequestFailure
  },
  updateCommentRequestActions: {
    request: Creators.updateCommentRequestRequest,
    success: Creators.updateCommentRequestSuccess,
    errors: Creators.updateCommentRequestFailure
  },
  deleteScreenshotsRequestActions: {
    request: Creators.deleteScreenshotsRequestRequest,
    success: Creators.deleteScreenshotsRequestSuccess,
    errors: Creators.deleteScreenshotsRequestFailure
  }
}

const eventsOptions = {
  [constants.SAVE_SCREENSHOTS_REQUEST_REQUEST]: {
    api: services.saveScreenshotsRequest,
    actions: actions.saveScreenshotsRequestActions
  },
  [constants.UPDATE_COMMENT_REQUEST_REQUEST]: {
    api: services.updateCommentRequest,
    actions: actions.updateCommentRequestActions
  },
  [constants.DELETE_SCREENSHOTS_REQUEST_REQUEST]: {
    api: services.deleteScreenshotsRequest,
    actions: actions.deleteScreenshotsRequestActions
  }
}

export default function* apiSaga() {
  yield takeLatest(constants.SAVE_SCREENSHOTS_REQUEST_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.SAVE_SCREENSHOTS_REQUEST_REQUEST])
  )
  yield takeLatest(constants.UPDATE_COMMENT_REQUEST_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.UPDATE_COMMENT_REQUEST_REQUEST])
  )
  yield takeLatest(constants.DELETE_SCREENSHOTS_REQUEST_REQUEST, (action) =>
    apiGeneratorDelete(action, eventsOptions[constants.DELETE_SCREENSHOTS_REQUEST_REQUEST])
  )
}
